import { render, staticRenderFns } from "./detalle-salida.vue?vue&type=template&id=708670b8"
import script from "./detalle-salida.vue?vue&type=script&lang=js"
export * from "./detalle-salida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports